import {signal, WritableSignal} from "@angular/core";
import {Subject} from "rxjs";

export class FUICloseConfirmation {
    canClose: boolean | Promise<boolean>;
}

/**
 * Service injected by the FUIStackedPageService when a page is open.
 */
export class FUIStackedPageContextService {
    private _title: string;

    title$: WritableSignal<string> = signal<string>(undefined);

    readonly params: any;

    /**
     * This observable is triggered when the page is validateable to close. The guest page should listen to this event and set the canClose to true or false
     * @type {Subject<any>}
     */
    readonly onCloseRequest: Subject<FUICloseConfirmation> = new Subject();

    /**
     * This observable is triggered when the guest page is confirmed.
     * @type {Subject<any>}
     */
    readonly onConfirm: Subject<any> = new Subject();

    /**
     * This observable is triggered when the guest page is cancelled.
     * @type {Subject<void>}
     */
    readonly onCancel: Subject<void> = new Subject();

    constructor(params: any) {
        this.params = params;
    }

    /**
     * Confirm the result for the guest page
     * @param result
     */
    confirm(result: any): void {
        this.onConfirm.next(result);
    }

    /**
     * Cancel the guest page
     */
    cancel(): void {
        this.onCancel.next();
    }

    /**
     * Request that the guest page should close
     */
    requestClose(): void {
        this.onCloseRequest.next(undefined);
    }

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
        this.title$.set(value);
    }
}
